
import { useNavigate } from 'react-router-dom';

export default function ComparisonCTA() {
  const navigate = useNavigate();

  const goToContact = () => {
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById('contact-form');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  };

  const goToDiagnosis = () => {
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById('diagnosis');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  };

  const diagnosisSteps = [
    { icon: 'ri-user-settings-line', title: '働き方を選択', desc: '集中型 or 創造型' },
    { icon: 'ri-time-line', title: '作業時間を選択', desc: '短時間 or 長時間' },
    { icon: 'ri-heart-pulse-line', title: '重視点を選択', desc: '効率 or 健康' },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        {/* Final Diagnosis CTA - Enhanced */}
        <div className="relative bg-gradient-to-br from-[#f5f3ef] via-white to-[#f5f3ef] rounded-3xl border-2 border-[#e8e6e3] overflow-hidden mb-12">
          {/* Decorative */}
          <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-[#3d6b4a] via-[#2c4a6e] to-[#c9a86c]"></div>
          
          <div className="px-8 py-14 md:px-14">
            <div className="text-center mb-10">
              <div className="inline-flex items-center gap-2 bg-[#1a2332] px-4 py-2 rounded-full mb-6">
                <i className="ri-lightbulb-flash-line text-[#c9a86c]"></i>
                <span className="text-xs font-bold text-white tracking-wider">まだ迷っている方へ</span>
              </div>
              <h2 className="text-3xl font-bold text-[#1a2332] mb-3" style={{ fontFamily: 'Noto Serif JP, serif' }}>
                たった3ステップで最適モデルがわかる
              </h2>
              <p className="text-sm text-[#4a4a4a] max-w-lg mx-auto">
                比較表を見ても決められない…そんな方のために、<br />
                簡単な質問であなたに最適なモデルを診断します。
              </p>
            </div>

            {/* Steps */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
              {diagnosisSteps.map((step, i) => (
                <div key={i} className="relative">
                  <div className="bg-white rounded-2xl p-6 text-center shadow-sm border border-[#e8e6e3] hover:shadow-md hover:border-[#c9a86c]/30 transition-all">
                    <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-7 h-7 rounded-full bg-[#1a2332] text-white text-xs font-bold flex items-center justify-center">
                      {i + 1}
                    </div>
                    <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#c9a86c]/20 to-[#c9a86c]/5 flex items-center justify-center mx-auto mb-4">
                      <i className={`${step.icon} text-2xl text-[#c9a86c]`}></i>
                    </div>
                    <h3 className="text-sm font-bold text-[#1a2332] mb-1">{step.title}</h3>
                    <p className="text-xs text-[#4a4a4a]">{step.desc}</p>
                  </div>
                  {i < 2 && (
                    <div className="hidden md:block absolute top-1/2 -right-3 -translate-y-1/2 z-10">
                      <i className="ri-arrow-right-line text-xl text-[#c9a86c]"></i>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Result Preview */}
            <div className="bg-[#1a2332] rounded-2xl p-6 mb-10">
              <div className="flex items-center justify-center gap-8 flex-wrap">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-[#3d6b4a] flex items-center justify-center">
                    <span className="text-xs font-bold text-white">Core</span>
                  </div>
                  <div className="text-left">
                    <div className="text-xs text-white/60">コスパ重視なら</div>
                    <div className="text-sm font-bold text-white">Core</div>
                  </div>
                </div>
                <div className="w-px h-10 bg-white/20 hidden md:block"></div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-[#2c4a6e] flex items-center justify-center">
                    <span className="text-xs font-bold text-white">Pro</span>
                  </div>
                  <div className="text-left">
                    <div className="text-xs text-white/60">高機能重視なら</div>
                    <div className="text-sm font-bold text-white">Pro</div>
                  </div>
                </div>
                <div className="w-px h-10 bg-white/20 hidden md:block"></div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-[#c9a86c] flex items-center justify-center">
                    <span className="text-xs font-bold text-[#1a2332]">Style</span>
                  </div>
                  <div className="text-left">
                    <div className="text-xs text-white/60">健康重視なら</div>
                    <div className="text-sm font-bold text-white">Style</div>
                  </div>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <div className="text-center">
              <button
                onClick={goToDiagnosis}
                className="group relative bg-gradient-to-r from-[#c9a86c] to-[#d4b87a] text-[#1a2332] px-12 py-5 rounded-full text-base font-bold hover:shadow-xl hover:shadow-[#c9a86c]/30 transition-all inline-flex items-center gap-3 whitespace-nowrap cursor-pointer overflow-hidden"
              >
                <span className="absolute inset-0 bg-white/30 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-500"></span>
                <i className="ri-stethoscope-line text-xl relative"></i>
                <span className="relative">今すぐ無料診断を受ける</span>
                <i className="ri-arrow-right-line text-xl relative group-hover:translate-x-1 transition-transform"></i>
              </button>
              <p className="text-xs text-[#4a4a4a] mt-4">
                <i className="ri-time-line mr-1"></i>所要時間わずか30秒・登録不要
              </p>
            </div>
          </div>
        </div>

        {/* Contact CTA */}
        <div className="bg-[#f5f3ef] rounded-2xl p-10 text-center">
          <h3 className="text-xl font-bold text-[#1a2332] mb-3" style={{ fontFamily: 'Noto Serif JP, serif' }}>
            法人様向け特別プランのご相談
          </h3>
          <p className="text-sm text-[#4a4a4a] mb-6 max-w-lg mx-auto">
            部署・フロア単位での混在導入プランや数量割引について、お気軽にお問い合わせください。
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <button
              onClick={goToContact}
              className="bg-[#1a2332] text-white px-8 py-3.5 rounded-full text-sm font-bold hover:bg-[#2c3e50] transition-all inline-flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <span>無料見積もりを依頼する</span>
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
            <a
              href="tel:03-0000-0000"
              className="border-2 border-[#1a2332] text-[#1a2332] px-8 py-3.5 rounded-full text-sm font-bold hover:bg-[#1a2332]/5 transition-all inline-flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-lg"></i>
              <span>お電話でのご相談</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
